import api from './api';

const formaPagamentoService = {
  // Listar formas de pagamento com paginação
  list: async (params = {}) => {
    try {
      const response = await api.get('/formapagamento', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao listar formas de pagamento:', error);
      throw error;
    }
  },

  // Listar todas as formas de pagamento ativas para selects
  getAll: async () => {
    try {
      const response = await api.get('/formapagamento/all');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar formas de pagamento:', error);
      throw error;
    }
  },

  // Buscar forma por ID
  getById: async (id) => {
    try {
      const response = await api.get(`/formapagamento/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar forma de pagamento:', error);
      throw error;
    }
  },

  // Listar todas as formas ativas para selects
  getAll: async () => {
    try {
      const response = await api.get('/formapagamento/all');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar formas de pagamento:', error);
      throw error;
    }
  },

  // Criar nova forma
  create: async (data) => {
    try {
      const response = await api.post('/formapagamento', data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar forma de pagamento:', error);
      throw error;
    }
  },

  // Atualizar forma
  update: async (id, data) => {
    try {
      const response = await api.put(`/formapagamento/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar forma de pagamento:', error);
      throw error;
    }
  },

  // Excluir forma
  delete: async (id) => {
    try {
      const response = await api.delete(`/formapagamento/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao excluir forma de pagamento:', error);
      throw error;
    }
  }
};

// Exports nomeados para compatibilidade com componentes existentes
export const fetchFormaPagamento = formaPagamentoService.list;
export const createFormaPagamento = formaPagamentoService.create;
export const updateFormaPagamento = formaPagamentoService.update;
export const deleteFormaPagamento = formaPagamentoService.delete;

export default formaPagamentoService;
